import React, { useEffect, useState } from "react";
import { api, formatApiError } from "../../lib/api";
import { C } from "./AccountingLayout";
import { toast } from "sonner";
import { Calendar } from "lucide-react";

const money = (n) => `₦${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}`;

export default function BranchComparison() {
  const today = new Date();
  const weekAgo = new Date(); weekAgo.setDate(today.getDate() - 6);
  const [df, setDf] = useState(weekAgo.toISOString().slice(0, 10));
  const [dt, setDt] = useState(today.toISOString().slice(0, 10));
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = () => {
    setLoading(true);
    api.get("/accounting/branch-comparison", { params: { date_from: df, date_to: dt } })
      .then(setData).catch((e) => toast.error(formatApiError(e))).finally(() => setLoading(false));
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [df, dt]);

  return (
    <div className="space-y-4" data-testid="branch-comparison">
      <div className="flex flex-wrap items-center gap-3 p-4 rounded-2xl" style={{ background: C.panel, border: `1px solid ${C.border}` }}>
        <Calendar size={16} style={{ color: C.burgundy }} />
        <input type="date" value={df} onChange={(e) => setDf(e.target.value)} data-testid="cmp-from" className="h-9 px-3 rounded-lg text-sm" style={{ border: `1px solid ${C.border}` }} />
        <span style={{ color: C.softMuted }}>→</span>
        <input type="date" value={dt} onChange={(e) => setDt(e.target.value)} data-testid="cmp-to" className="h-9 px-3 rounded-lg text-sm" style={{ border: `1px solid ${C.border}` }} />
        <div className="text-xs" style={{ color: C.softMuted }}>{loading ? "Loading…" : `${data?.rows?.length || 0} branches`}</div>
      </div>
      {data && (
        <div className="rounded-2xl border overflow-x-auto" style={{ background: C.panel, borderColor: C.border }}>
          <table className="w-full text-sm">
            <thead><tr style={{ color: C.softMuted, background: C.borderSoft }}>
              {["Branch", "Revenue", "COGS", "Gross Profit", "Margin", "Discounts", "Expenses", "Net Op", "Cash", "Card", "Transfer", "Cash Var", "Orders"].map((h) => (
                <th key={h} className="text-left py-3 px-3 text-[10px] tracking-widest whitespace-nowrap">{h}</th>
              ))}
            </tr></thead>
            <tbody>
              {data.rows.map((r) => (
                <tr key={r.location_id} className="border-t hover:bg-[#FBF8F2]" style={{ borderColor: C.borderSoft, color: C.text }} data-testid={`cmp-row-${r.location_id}`}>
                  <td className="py-2.5 px-3 font-semibold">{r.location_name}</td>
                  <td className="py-2.5 px-3">{money(r.revenue)}</td>
                  <td className="py-2.5 px-3">{money(r.cogs)}</td>
                  <td className="py-2.5 px-3 font-semibold" style={{ color: r.gross_profit >= 0 ? C.green : C.red }}>{money(r.gross_profit)}</td>
                  <td className="py-2.5 px-3">{r.gross_margin_pct}%</td>
                  <td className="py-2.5 px-3">{money(r.discounts)}</td>
                  <td className="py-2.5 px-3">{money(r.expenses)}</td>
                  <td className="py-2.5 px-3 font-semibold" style={{ color: r.net_operating >= 0 ? C.green : C.red }}>{money(r.net_operating)}</td>
                  <td className="py-2.5 px-3">{money(r.cash)}</td>
                  <td className="py-2.5 px-3">{money(r.card)}</td>
                  <td className="py-2.5 px-3">{money(r.transfer)}</td>
                  <td className="py-2.5 px-3" style={{ color: Math.abs(r.cash_variance) > 0.01 ? C.red : C.text }}>{money(r.cash_variance)}</td>
                  <td className="py-2.5 px-3">{r.order_count}</td>
                </tr>
              ))}
            </tbody>
            <tfoot><tr className="border-t font-semibold" style={{ borderColor: C.border, color: C.text, background: C.borderSoft }}>
              <td className="py-2.5 px-3">Total</td>
              <td className="py-2.5 px-3">{money(data.totals.revenue)}</td>
              <td className="py-2.5 px-3">{money(data.totals.cogs)}</td>
              <td className="py-2.5 px-3">{money(data.totals.gross_profit)}</td>
              <td /><td className="py-2.5 px-3">{money(data.totals.discounts)}</td>
              <td className="py-2.5 px-3">{money(data.totals.expenses)}</td>
              <td className="py-2.5 px-3">{money(data.totals.net_operating)}</td>
              <td className="py-2.5 px-3">{money(data.totals.cash)}</td>
              <td className="py-2.5 px-3">{money(data.totals.card)}</td>
              <td className="py-2.5 px-3">{money(data.totals.transfer)}</td>
              <td className="py-2.5 px-3">{money(data.totals.cash_variance)}</td>
              <td />
            </tr></tfoot>
          </table>
        </div>
      )}
    </div>
  );
}
